import { ApplicationSubMenuOutputWithStatus } from './application-sub-menu-output-with-status.model';


export class SelectByMenuSubIdOutput implements ISelectByMenuSubIdOutput {
    status!: number;
    message!: string;
    data!: ApplicationSubMenuOutputWithStatus;

    constructor(data?: ISelectByMenuSubIdOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.message = _data["message"];
            this.data = _data["data"] ? ApplicationSubMenuOutputWithStatus.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SelectByMenuSubIdOutput {
        data = typeof data === 'object' ? data : {};
        let result = new SelectByMenuSubIdOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data; 
    }
}

export interface ISelectByMenuSubIdOutput {
    status: number;
    message: string;
    data: ApplicationSubMenuOutputWithStatus;
}

